"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectMenu = exports.getOptionName = void 0;
const react_1 = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Icon_1 = require("../Icon/Icon");
const BaseComponents_1 = require("./BaseComponents");
const FilterInput_1 = require("../FilterInput/FilterInput");
const Tooltip_1 = require("../Tooltip/Tooltip");
const getOptionName = (option) => typeof option === 'string' ? option : option.optionName;
exports.getOptionName = getOptionName;
const processFontSize = (fontSize = '16px') => fontSize === '14' || fontSize === '16' ? `${fontSize}px` : fontSize;
const MenuItemText = Theme_1.styled.span `
  color: ${(props) => props.theme[props.color || 'gray'] || props.color};
  padding-right: 6px;
  flex: none;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: ${(props) => processFontSize(props.fontSize)};
`;
const returnIconSize = (fontSize) => (fontSize === '14' ? '16' : '18');
const Menu = (props) => {
    const { color, fontSize, menuLocation, menuOptions, sectionOptions, hasSections, onOptionSelected, selectedOption, width, searcher, selectedOptionComparator, renderOption, onClose, } = props;
    const [currentOption, setCurrentOption] = (0, react_1.useState)(selectedOption);
    const [filterData, setFilterData] = (0, react_1.useState)(menuOptions);
    const [showSection] = (0, react_1.useState)(hasSections && sectionOptions != undefined);
    const handleSelectionChange = (option, index) => {
        const isSameOption = selectedOptionComparator
            ? selectedOptionComparator(currentOption, option)
            : (option === null || option === void 0 ? void 0 : option.optionName) === (currentOption === null || currentOption === void 0 ? void 0 : currentOption.optionName);
        const newOption = isSameOption ? { optionName: '' } : option;
        setCurrentOption(newOption);
        onOptionSelected(newOption, newOption.optionName ? index : undefined);
        onClose();
    };
    const handleFilter = ({ target, }) => __awaiter(void 0, void 0, void 0, function* () {
        const searchWord = target.value;
        const newFilter = menuOptions.filter((value) => {
            return (0, exports.getOptionName)(value)
                .toLowerCase()
                .includes(searchWord.toLowerCase());
        });
        setFilterData(newFilter);
    });
    const handleClick = (e) => {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    };
    const MenuItemListDefault = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !filterData.length && (react_1.default.createElement(BaseComponents_1.MenuItemNoResults, null,
                react_1.default.createElement(MenuItemText, { color: color, fontSize: fontSize }, "No Results"))),
            filterData.map((option, index) => (react_1.default.createElement(BaseComponents_1.MenuItem, { onClick: () => handleSelectionChange(option, index), key: `SingleSelectMenu_${option.optionName}` }, renderOption ? (renderOption(option)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(MenuItemText, { color: color, fontSize: fontSize, key: `SingleSelectMenu_${option.optionName}_text` }, option.optionName),
                option.optionName === (currentOption === null || currentOption === void 0 ? void 0 : currentOption.optionName) && (react_1.default.createElement(Icon_1.Icon, { key: `SingleSelectMenu_selected_icon`, icon: 'check', size: returnIconSize(fontSize) })))))))));
    };
    const renderSelectedIcon = (option) => {
        if (selectedOptionComparator) {
            return (selectedOptionComparator(currentOption, option) && (react_1.default.createElement(Icon_1.Icon, { key: `SingleSelectMenu_selected_icon`, icon: 'check', size: returnIconSize(fontSize) })));
        }
        else if (option.optionName === (currentOption === null || currentOption === void 0 ? void 0 : currentOption.optionName)) {
            return (react_1.default.createElement(Icon_1.Icon, { key: `SingleSelectMenu_selected_icon`, icon: 'check', size: returnIconSize(fontSize) }));
        }
        return null;
    };
    const MenuItemListSectioned = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null, sectionOptions === null || sectionOptions === void 0 ? void 0 : sectionOptions.map((section) => {
            return (react_1.default.createElement("div", { key: `SingleSelectMenu_${section.options[0].optionName}` },
                react_1.default.createElement("div", { className: "sectionHeader" }, section.sectionHeader),
                section.options.map((option, index) => (react_1.default.createElement(BaseComponents_1.MenuItem, { onClick: () => handleSelectionChange(option, index), key: `SingleSelectMenu_${option.optionName}` }, renderOption ? (renderOption(option)) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(MenuItemText, { color: color, fontSize: fontSize, key: `SingleSelectMenu_${option.optionName}_text` }, option.optionName),
                    renderSelectedIcon(option))))))));
        })));
    };
    return (react_1.default.createElement(BaseComponents_1.MenuContainer, { className: "SingleSelectMenuContainer", onMouseDown: (e) => e.preventDefault(), menuLocation: menuLocation, width: width },
        searcher && (react_1.default.createElement(BaseComponents_1.SearchContainer, { onClick: handleClick },
            react_1.default.createElement(FilterInput_1.FilterInput, { icon: "search", placeholder: "Search", width: "100%", onChange: handleFilter }))),
        react_1.default.createElement(BaseComponents_1.MenuItemsContainer, null, showSection ? react_1.default.createElement(MenuItemListSectioned, null) : react_1.default.createElement(MenuItemListDefault, null))));
};
const SortMenu = (props) => {
    const { onSortOptionSelected, menuLocation, menuOptions, fontSize, selectedOption, sortDirection, onClose, } = props;
    const defaultState = {
        internalSelectedOption: selectedOption || { optionName: '' },
        internalSortDirection: sortDirection,
    };
    const [currentState, updateCurrentState] = (0, react_1.useState)(defaultState);
    const { internalSelectedOption, internalSortDirection } = currentState;
    const iconToDisplay = (internalSortDirection === null || internalSortDirection === void 0 ? void 0 : internalSortDirection.toUpperCase()) === 'ASC' ? 'arrowDown' : 'arrowUp';
    const handleSelectionChange = (option, index) => {
        const newState = Object.assign({}, currentState);
        if (internalSelectedOption.optionName != option.optionName) {
            newState.internalSelectedOption = option;
            internalSortDirection ? null : (newState.internalSortDirection = 'ASC');
        }
        else {
            newState.internalSortDirection =
                internalSortDirection === 'ASC' ? 'DESC' : 'ASC';
            newState.internalSelectedOption = option;
        }
        updateCurrentState(newState);
        onSortOptionSelected(option, newState.internalSortDirection, index);
        onClose();
    };
    return (react_1.default.createElement(BaseComponents_1.MenuContainer, { className: "SingleSelectMenuContainer", onMouseDown: (e) => e.preventDefault(), menuLocation: menuLocation }, menuOptions.map((option, index) => (react_1.default.createElement(BaseComponents_1.MenuItem, { onClick: () => handleSelectionChange(option, index), key: `SingleSelectMenu_${option.optionName}` },
        react_1.default.createElement(MenuItemText, { key: `SingleSelectMenu_${option.optionName}_text` }, option.optionName),
        option.optionName === internalSelectedOption.optionName && (react_1.default.createElement(Icon_1.Icon, { key: `SingleSelectMenu_selected_icon`, icon: iconToDisplay, size: returnIconSize(fontSize) })))))));
};
const SingleSelectMenu = (props) => {
    function isSortMenu(props) {
        return (props
            .onSortOptionSelected !== undefined);
    }
    const [isMenuOpen, setMenuOpen] = (0, react_1.useState)(false);
    const onBlur = function () {
        var _a;
        setMenuOpen(false);
        (_a = props.setMenuOpen) === null || _a === void 0 ? void 0 : _a.call(props, false);
    };
    const onClick = () => {
        var _a;
        if (!props.disabled) {
            setMenuOpen(!isMenuOpen);
            (_a = props.setMenuOpen) === null || _a === void 0 ? void 0 : _a.call(props, !isMenuOpen);
        }
    };
    const ClonedVisualEle = (0, react_1.cloneElement)(props.VisualElement, {
        onClick,
    });
    const menuClassName = isSortMenu(props)
        ? 'SingleSelectSortMenu'
        : 'SingleSelectMenu';
    const menuToRender = isSortMenu(props) ? (react_1.default.createElement(SortMenu, Object.assign({}, props, { onClose: onBlur }))) : (react_1.default.createElement(Menu, Object.assign({}, props, { onClose: onBlur })));
    return (react_1.default.createElement(BaseComponents_1.MenuComponentWrapper, { tabIndex: 0, onBlur: onBlur, className: menuClassName, width: props.width },
        props.toolTipTitle ? (react_1.default.createElement(Tooltip_1.Tooltip, { title: props.toolTipTitle, placement: props.toolTipPlacement }, ClonedVisualEle)) : (ClonedVisualEle),
        isMenuOpen && menuToRender));
};
exports.SingleSelectMenu = SingleSelectMenu;
//# sourceMappingURL=SingleSelectMenu.js.map